<template>
  <v-container fluid fill-height>
    <v-layout row wrap>
      <v-flex sm12>
        <v-toolbar
          color="#eee"
          class="elevation-0 secondary--text mb-4"
          style="background: transparent" >
          <v-toolbar-title>Meus Frentistas</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" width="400" :fullscreen="$vuetify.breakpoint.xs">
            <v-btn icon color='info' slot="activator">
              <v-icon>add</v-icon>
            </v-btn>
            <cad-frentista :posto="posto" @complete="frentistaSalvo"></cad-frentista>
          </v-dialog>
          <v-dialog lazy :value="dialogLiberarAcesso" width="400" :fullscreen="$vuetify.breakpoint.xs">
            <liberar-acesso-frentista :frentista="frentistaLiberarAcesso" :posto="posto" @complete="frentistaSalvo"></liberar-acesso-frentista>
          </v-dialog>
        </v-toolbar>
        <v-data-table
          hide-actions
          :hide-headers="!frentistas || !frentistas.length"
          :items="frentistas"
          :headers="frentistasHeaders"
          class="elevation-1"
        >
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              Desculpe, não encontramos nenhum dado!
            </v-alert>
          </template>
          <template v-slot:items="props">
            <tr>
              <td style="width: 10px">
                <v-avatar
                  color="grey"
                  size="30">
                  <img v-if="props.item.pessoa && props.item.pessoa.url_imagem_perfil" :src="props.item.pessoa.url_imagem_perfil" alt="trevor">
                  <v-icon dark v-else>face</v-icon>
                </v-avatar>
              </td>
              <td>{{ props.item.nome ? props.item.nome : props.item.pessoa ? props.item.pessoa.nome : '' }}</td>
              <td class="text-xs-left">{{ props.item.cpf ? props.item.cpf : props.item.pessoa ? props.item.pessoa.cpf : '' }}</td>
              <td class="text-xs-left">{{ props.item.matricula  }}</td>
              <td class="text-xs-center" style="width: 50px">
                <v-layout align-center justify-center>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                       <v-switch class="lean-input" v-on="on" value @click.stop="() => ativarGerente(props.item, props.index)" :input-value="props.item.gerente"></v-switch>
                    </template>
                    Habilite os gerentes
                  </v-tooltip>
                </v-layout>
              </td>
              <td class="text-xs-center" style="width: 50px">
                <v-layout align-center justify-center>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                       <v-switch class="lean-input" v-on="on" value @click.stop="() => ativarControlePrecos(props.item, props.index)" :input-value="props.item.controle_precos"></v-switch>
                    </template>
                    Permite controlar preços
                  </v-tooltip>
                </v-layout>
              </td>
              <td class="text-xs-center" style="width: 50px">
                <v-layout align-center justify-center>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                       <v-switch class="lean-input" v-on="on" value @click.stop="() => ativarControleFrentistas(props.item, props.index)" :input-value="props.item.controle_frentistas"></v-switch>
                    </template>
                    Permite controlar frentistas
                  </v-tooltip>
                </v-layout>
              </td>
              <td class="text-xs-center" style="width: 50px">
                <v-layout align-center justify-center>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                       <v-switch class="lean-input" v-on="on" value @click.stop="() => ativarControleCashposto(props.item)" :input-value="props.item.controle_cashposto"></v-switch>
                    </template>
                    Permite venda de CashPosto para clientes
                  </v-tooltip>
                </v-layout>
              </td>
              <td class="text-xs-center" style="width: 30px">
                <v-layout align-center justify-center>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                       <v-checkbox
                       class="lean-input mt-3 mb-0"
                        v-on="on"
                        value
                        @click.stop="() => !props.item.pessoa ? liberarAcesso(props.item, props.index) : false"
                        :input-value="!!props.item.pessoa"
                      ></v-checkbox>
                    </template>
                    {{ !props.item.pessoa ? 'Conceder acesso a este frentista' : 'Este frentista já possui acesso' }}
                  </v-tooltip>
                </v-layout>
              </td>
              <td
                class="text-xs-right"
                style="
                  justify-content: space-around;
                  flex-direction: row;
                  display: flex;
                "
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      icon
                      flat
                      color="info"
                      @click="
                        frentista = props.item,
                        dialogEditarFrentista = true
                      "
                    >
                      <v-icon>edit</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar Informações</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon flat color="info" @click="detalhesFrentista(props.item)">
                      <v-icon>assignment_ind</v-icon>
                    </v-btn>
                  </template>
                  <span>Visualizar Informações</span>
                </v-tooltip>
                 <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon flat color="info" @click="mostrarAvaliacao(props.item)">
                      <v-icon>star</v-icon>
                    </v-btn>
                  </template>
                  <span>Visualizar avaliações</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-dialog v-if="frentista" v-model="dialogDetalheFrentista" width="400" :fullscreen="$vuetify.breakpoint.xs">
      <v-card color="lighten-3" class="primary--text pe-3">
        <v-card-text>
          <v-layout>
            <v-flex xs3 class="pt-4 pl-4">
              <v-layout align-center justify-center column >
                <v-avatar
                  color="grey"
                  size="60">
                    <img v-if="frentista.pessoa && frentista.pessoa.url_imagem_perfil" :src="frentista.pessoa.url_imagem_perfil" alt="trevor">
                    <v-icon dark v-else>face</v-icon>
                </v-avatar>
              </v-layout>
            </v-flex>
            <v-flex xs9>
              <v-card-title class="text-xs-left">
                <v-layout column justify-start>
                  <div class="headline">{{ frentista.nome }} {{ frentista.sobrenome }}</div>
                  <div>CPF: {{ frentista.cpf }}</div>
                  <div>Mat.: {{ frentista.matricula }}</div>
                </v-layout>
              </v-card-title>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-list two-line v-if="frentista.pessoa">
          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="grey">phone</v-icon>
            </v-list-tile-action>

            <v-list-tile-content v-if="frentista.pessoa">
              <v-list-tile-title>{{ frentista.pessoa.telefone }}</v-list-tile-title>
              <v-list-tile-sub-title>Telefone principal</v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-btn color="info" icon flat>
                <v-icon>chat</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>

          <v-divider inset></v-divider>

          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="grey">mail</v-icon>
            </v-list-tile-action>

            <v-list-tile-content v-if="frentista.pessoa">
              <v-list-tile-title>{{ frentista.pessoa.email }}</v-list-tile-title>
              <v-list-tile-sub-title>Email pessoal</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider inset></v-divider>
        </v-list>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn icon flat color="red" @click.prevent="() => removerFrentista(frentista)">
            <v-icon>delete_forever</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogEditarFrentista"
      v-if="dialogEditarFrentista"
      width="35em"
    >
      <editar-frentista
        :frentista="frentista"
        @fechar="
          dialogEditarFrentista = false,
          frentista = undefined
        "
        @carregar="carregarFrentistas"
      />
    </v-dialog>
    <v-dialog
      v-model="dialogAutenticacao"
      v-if="dialogAutenticacao"
      width="35em"
    >
      <autenticacao-por-sms
        :frentista="frentista"
        @fechar="dialogAutenticacao = false"
        @callDialog="autenticado = true, ativarControleCashposto()"
        @error="errorSnackbar"
        @success="sucessSnackbar"
      />
    </v-dialog>
    <v-snackbar
      v-model="snackbar.active"
      :color="snackbar.color"
      :multi-line="snackbar.multiLine"
      :timeout="snackbar.timeout"
      :vertical="snackbar.vertical"
    >
      {{ snackbar.text }}
      <v-btn
        flat
        @click="snackbar.active = false"
      >
        Fechar
      </v-btn>
    </v-snackbar>
    <dialog-avaliacao-frentista
      v-model="dialogAvalicaoFrentista"
      :avaliacoes="avaliacoesDoFrentista"
      :frentista="frentistaSelecionado"
      :carregando="carregandoAvaliacoes"
    />
  </v-container>
</template>

<script>
import CadFrentista from '@/components/cadastros/CadFrentista'
import LiberarAcessoFrentista from '@/components/cadastros/LiberarAcessoFrentista'
import EditarFrentista from '@/components/dialogs/EditarFrentista'
import DialogAvaliacaoFrentista from '@/components/dialogs/DialogAvaliacaoFrentista'
import AutenticacaoPorSms from '@/components/dialogs/SmartLock'

export default {
  components: {
    CadFrentista,
    LiberarAcessoFrentista,
    EditarFrentista,
    AutenticacaoPorSms,
    DialogAvaliacaoFrentista
  },
  data () {
    return {
      dialogDetalheFrentista: false,
      dialogEditarFrentista: false,
      dialogAutenticacao: false,
      dialogAvalicaoFrentista: false,
      avaliacoesDoFrentista: [],
      frentistaSelecionado: null,
      autenticado: false,
      carregandoAvaliacoes: false,
      snackbar: {
        active: false,
        color: '',
        multiLine: true,
        timeout: 4000,
        vertical: true,
        text: ''
      },
      dialog: false,
      frentistaLiberarAcesso: null,
      totalItems: 0,
      frentista: null,
      frentistasHeaders: [
        {
          align: 'left',
          sortable: false
        },
        {
          text: 'Nome',
          align: 'left',
          sortable: false,
          value: 'nome'
        },
        {
          text: 'CPF',
          align: 'left',
          sortable: false,
          value: 'cpf'
        },
        {
          text: 'Matrícula',
          align: 'left',
          sortable: false,
          value: 'matricula'
        },
        {
          text: 'Gerente',
          align: 'center',
          sortable: false
        },
        {
          text: 'Preços',
          align: 'center',
          sortable: false
        },
        {
          text: 'Admissão',
          align: 'center',
          sortable: false
        },
        {
          text: 'CashPosto',
          align: 'center',
          sortable: false
        },
        {
          text: 'Acesso',
          align: 'center',
          sortable: false
        },
        {
          align: 'right',
          sortable: false
        }
      ],
      list_Usuarios: []
    }
  },
  computed: {
    dialogLiberarAcesso () {
      return !!this.frentistaLiberarAcesso
    },
    posto () {
      return this.$store.getters.posto
    },
    frentistas () {
      return this.$store.getters.frentistas
    },
    ready () {
      return !!this.posto
    }
  },
  mounted () {
    if (this.ready) {
      this.carregarFrentistas()
    }
  },
  watch: {
    ready (val) {
      if (val) {
        this.carregarFrentistas()
      }
    },
    dialogDetalheFrentista (val) {
      if (val === false) {
        this.frentista = null
      }
    },
    dialogAvalicaoFrentista (val) {
      if (val === false) {
        this.frentistaSelecionado = null
        this.avaliacoesDoFrentista = []
        this.carregandoAvaliacoes = false
      }
    }
  },
  methods: {
    errorSnackbar (text) {
      this.snackbar.color = 'error'
      this.snackbar.text = text
      this.snackbar.active = true
    },
    sucessSnackbar (text) {
      this.snackbar.color = 'primary'
      this.snackbar.text = text
      this.snackbar.active = true
    },
    detalhesFrentista (frentista) {
      this.frentista = frentista
      this.dialogDetalheFrentista = true
    },
    carregarFrentistas () {
      this.$store.dispatch('listarFrentistas')
    },
    fecharDialogFrentista () {
      this.dialog = false
    },
    frentistaSalvo () {
      this.carregarFrentistas()
      this.frentistaLiberarAcesso = null
      this.fecharDialogFrentista()
    },
    removerFrentista (frentista) {
      this.$store.dispatch('removerFrentista', {
        id: frentista.id_frentista
      }).then(() => {
        this.dialogDetalheFrentista = false
        this.carregarFrentistas()
      })
    },
    ativarGerente (frentista) {
      if (!frentista.pessoa) {
        this.errorSnackbar('Para ser gerente, o frentista precisar ter acesso concedido.')
        return
      }
      this.$store.dispatch('editarFrentista', {
        id_frentista: frentista.id_frentista,
        posto: this.posto.cnpj,
        gerente: !frentista.gerente
      }).catch((e) => {
        alert(e.message)
      })
    },
    ativarControlePrecos (frentista) {
      if (!frentista.pessoa) {
        this.errorSnackbar('Para ter sobre os preços, o frentista precisar ter acesso concedido.')
        return
      }
      this.$store.dispatch('editarFrentista', {
        id_frentista: frentista.id_frentista,
        posto: this.posto.cnpj,
        controle_precos: !frentista.controle_precos
      }).catch((e) => {
        alert(e.message)
      })
    },
    ativarControleFrentistas (frentista) {
      if (!frentista.pessoa) {
        this.errorSnackbar('Para ter controle de admissão, o frentista precisar ter acesso concedido.')
        return
      }
      this.$store.dispatch('editarFrentista', {
        id_frentista: frentista.id_frentista,
        posto: this.posto.cnpj,
        controle_frentistas: !frentista.controle_frentistas
      }).catch((e) => {
        alert(e.message)
      })
    },
    liberarAcesso (frentista) {
      this.frentistaLiberarAcesso = frentista
    },
    ativarControleCashposto (frentista) {
      if (this.autenticado) {
        this.$store.dispatch('editarFrentista', {
          id_frentista: this.frentista.id_frentista,
          posto: this.posto.cnpj,
          controle_cashposto: !this.frentista.controle_cashposto
        }).then(() => {
          this.frentista = null
          this.dialogAutenticacao = false
          this.autenticado = false
          this.carregarFrentistas()
        })
      } else {
        this.frentista = frentista
        this.dialogAutenticacao = true
      }
    },
    async mostrarAvaliacao (frentista) {
      this.frentistaSelecionado = frentista
      this.dialogAvalicaoFrentista = true
      this.avaliacoesDoFrentista = []
      this.carregandoAvaliacoes = true
      try {
        const avaliacoes = await this.$store.dispatch('buscarAvaliacoesFrentista', frentista)
        this.avaliacoesDoFrentista = avaliacoes
      } catch (error) {
        this.errorSnackbar('Não foi possível carregar as avaliações deste frentista.')
        this.dialogAvalicaoFrentista = false
      } finally {
        this.carregandoAvaliacoes = false
      }
    }
  }
}
</script>
<style>
  .lean-input, .lean-input .v-input--selection-controls__input {
    margin-right: 0;
    text-align: center;
  }
</style>
